import { Link } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-porcelain flex flex-col">
      <header className="bg-brand border-b border-brand/10 shadow-sm">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="text-white font-semibold text-lg tracking-tight hover:text-cream transition-colors">
            LINX Style Quiz
          </Link>
        </div>
      </header>
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 py-8">
        {children}
      </main>
      <footer className="bg-brand border-t border-brand/10 mt-auto">
        <div className="max-w-3xl mx-auto px-4 py-4 text-center text-sm text-white/50">
          Copyright © 2026 LINX Consulting | Published by DAA
        </div>
      </footer>
    </div>
  );
}
